const proxyDomain = process.env.REACT_APP_PROXY_API_URL;

export const BASE_URL = `${proxyDomain}/api`;

export const PROXY_API = {
  GET: {
    USER: {
      CLAIMS: '/user/claims',
      PRINCIPAL: '/user/:tan/principal',
    },
    CUSTOMER: {
      WITH_TAN: 'customer/:tan',
      PRINCIPAL: 'customer/principal',
    },
    GEOFENCE: {
      VEHICLES_WITH_GEOFENCE_CHECK: '/geofenceV2/:tan/geofences/vehicles-with-geofence',
    },
    SIGN_IN: {
      REFRESH_TOKEN: 'signin/refreshtoken',
    },
    FEATURE_FLAGS: {
      FLAGS: '/feature-flags',
    },
  },
};
